
import {
  computed,
  defineComponent,
  inject,
  onBeforeMount,
  onBeforeUnmount
} from 'vue';
import type { BaseTab, BaseTabProvider } from './types';

export default defineComponent({
  props: {
    title: {
      type: String,
      required: true
    },
    id: {
      type: String,
      required: true
    },
    lazy: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const { addTab, removeTab, tabs }: BaseTabProvider =
      inject('baseTabsProvider');

    const selected = computed(() => {
      const tab = tabs.value.find((tab: BaseTab) => tab.id === props.id);
      return tab?.selected;
    });

    const showTab = computed(() => {
      // Always load non lazy loaded tab by default
      if (!props.lazy) {
        return true;
      }
      return selected.value;
    });

    onBeforeMount(() => {
      addTab({
        selected: false,
        title: props.title,
        id: props.id
      });
    });

    onBeforeUnmount(() => {
      removeTab(props.id);
    });

    return {
      showTab,
      selected
    };
  }
});
